import { render, staticRenderFns } from "./profilesPage.vue?vue&type=template&id=9af5d57c&scoped=true&"
import script from "./profilesPage.vue?vue&type=script&lang=js&"
export * from "./profilesPage.vue?vue&type=script&lang=js&"
import style0 from "./profilesPage.vue?vue&type=style&index=0&id=9af5d57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af5d57c",
  null
  
)

export default component.exports